import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MarketplaceManagerService } from 'src/app/services/marketplace-manager.service';
import { TenantWebchatConfigurationComponent } from '../tenant-webchat-configuration/tenant-webchat-configuration.component';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';

@Component({
  selector: 'app-tenant-homepage-configuration',
  template: `
    <div class="hp-head">
      <div class="t">
        <h2>Configure Homepage</h2>
        <p>Custom homepage HTML for a consumer tenant</p>
      </div>
      <span class="hp-x" mat-dialog-close>
        <svg
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </span>
    </div>

    <div class="hp-body" mat-dialog-content>
      <form [formGroup]="homepageForm" (ngSubmit)="onSubmit()" class="hp-form">
        <mat-form-field class="full">
          <mat-label>Tenant name</mat-label>
          <mat-select formControlName="tenant">
            <mat-option
              *ngFor="let tenant of tenantNames"
              [value]="tenant.name"
            >
              {{ tenant?.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <div class="fld">
          <label>Homepage HTML</label>
          <textarea
            class="html-area"
            formControlName="homepage_html_content"
            required
          ></textarea>
        </div>
      </form>
    </div>

    <mat-dialog-actions class="hp-foot">
      <button type="button" class="btn-ghost" mat-dialog-close>Close</button>
      <button type="button" class="btn-primary" (click)="onSubmit()">
        Submit
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./tenant-homepage-configuration.component.scss']
})
export class TenantHomepageConfigurationComponent implements OnInit {
  homepageForm: FormGroup | any;

  tenantNames: any = [];
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private marketPlaceManagerServices: MarketplaceManagerService,
    private dialogRef: MatDialogRef<TenantHomepageConfigurationComponent>,
    private sharedServices: SharedFeaturesService
  ){}

  ngOnInit(): void {
    this.homepageForm = this.formBuilder.group({
      homepage_html_content: ['', Validators.required],
      tenant: ['', Validators.required],
    });
    if (this.data) {
      this.homepageForm.patchValue({
        homepage_html_content: this.data.homepage_html_content || '',
        tenant: this.data.tenant || '',
      });
    }
    this.marketPlaceManagerServices.getAvailableTenant().subscribe({
      next: (response: any) => {
        this.tenantNames = response?.msg;
      },
      error: (error: any) => {
        console.error('An error occurred', error);
      },
    });
  }

  onSubmit() {
    if (this.homepageForm.valid) {
      this.dialogRef.close(this.homepageForm.value);
    } else {
      this.sharedServices.openSnackBar(
        'Invalid Data',
        'Close',
        'error-snackbar'
      );
    }
  }

}
